const slider = document.querySelector('.simple-wrapper');
const slides = slider.querySelectorAll(".simple-slide");
const progressBar = document.getElementById("progressBar");

const scrollToSlide = (index) => {
  const slideWidth = slides[0].offsetWidth + 1; // +1 for gap
  const scrollPosition = index * slideWidth;
  slider.scrollTo({ left: scrollPosition, behavior: "auto" });

  const totalSlides = slides.length;
  const progressPercent = ((index + 1) / totalSlides) * 100;
  progressBar.style.width = `${progressPercent}%`;
};

slider.addEventListener("scroll", () => {
  const slideWidth = slides[0].offsetWidth + 1;
  const index = Math.round(slider.scrollLeft / slideWidth);
  const totalSlides = slides.length;
  const progressPercent = ((index + 1) / totalSlides) * 100;
  progressBar.style.width = `${progressPercent}%`;
});

// Trigger on load
window.addEventListener("load", () => {
  scrollToSlide(0); // Scroll to first slide (index 0)
});

document.querySelector('.simple-back').addEventListener('click', function() {
  window.history.back();
});


document.querySelectorAll('.color-swatch').forEach(swatch => {
  swatch.addEventListener('click', function () {
    // Wait for active class to apply (Shopify usually does this after a small delay)
    setTimeout(() => {
      const activeMedia = document.querySelector(".product__media-item.active");
      if (activeMedia) {
        activeMedia.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    }, 500); // Adjust delay as needed
  });
});
